import { isWeb } from './BooleanUtility';

export const showSmartBanner = () => {
  if (!isWeb()) return;
  var banner = document.querySelector('.js_smartbanner');
  if (banner) {
    banner.style.setProperty('display', 'block', 'important');
    document.getElementById('root').style.height = 'calc(100% - 84px)';
    var html = document.querySelector('html');
    html.style.setProperty('margin-top', '84px', 'important');
  }
}

export const hideSmartBanner = () => {
  if (!isWeb()) return;
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isWebView =
    typeof window.ReactNativeWebView !== 'undefined' ||
    userAgent.includes('wv') ||
    userAgent.includes('WebView') ||
    /\bFBAN|FBAV\b/.test(userAgent);
  if (isWebView) return;
  var banner = document.querySelector('.js_smartbanner');
  if (banner) {
    banner.style.setProperty('display', 'none', 'important');
    document.getElementById('root').style.height = '100%';
    var html = document.querySelector('html');
    html.style.setProperty('margin-top', '0', 'important');
  }
}